import zh from './zh'
export default  {
  zh,
}